import { render, staticRenderFns } from "./supplierEcConfirm.vue?vue&type=template&id=157c4d44"
import script from "./supplierEcConfirm.vue?vue&type=script&lang=js"
export * from "./supplierEcConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports